import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";

import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
var eslipTable='';
var eslipTableDetails='';

class PhonePeTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeLists: [],
            txnTypeIDs: 'SALE',
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [{value: 'Settled', label: 'Settled'}, {value: 'Unsettled', label: 'Unsettled'}],
            isSettledIDs: '',
            isSettledValue: null,
            is_view_utid: false,
            isChange: false,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'phonePe_transaction');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        }
    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_filtered_echarge_slip_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'eChargeSlip_report','sparcs')
    }
    get_filtered_echarge_slip_report(object_type, object_code, event) {
        var that = this;

        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,

        };
        if ($.fn.DataTable.isDataTable('#eslipTable')) {
            $('#eslipTable').DataTable().clear().destroy();
        }
        var eslipTable = $('#eslipTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/echargeslip-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data":"Merchant Name", "width":"150px" },
                    {"data":"Chain", "width":"100px" },
                    {"data":"Store Name", "width":"100px"},
                    {"data":"Store Address", "width":"100px"},
                    {"data":"City"},
                    {"data":"BTID"},
                    {"data":"UTID"},
                    {"data":"Total No of transactions"},
                    {"data":"Transactions on Echargeslip"},
                    {"data":"Transactions on Paper roll"},


                ],
                "columnDefs": [
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2]
                    },

                ],
            });

        if ($.fn.DataTable.isDataTable('#eslipTableDetails')) {
            $('#eslipTableDetails').DataTable().clear().destroy();
        }
        var eslipTableDetails = $('#eslipTableDetails').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/echargeslip-details-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { console.log("amondon"); console.log(json.data[0]);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    // {"data":"prim_id", "width":"100px" },
                    {"data":"Merchant", "width":"100px" },
                    {"data":"Chain", "width":"100px" },
                    {"data":"Store", "width":"100px"},
                    {"data":"Store Address 1", "width":"100px"},
                    {"data":"Store Address 2", "width":"100px"},

                    {"data":"City"},
                    {"data":"Amount"},
                    {"data": "Transaction Date"},
                    {"data": "Transaction Time"},
                    {"data": "Btid"},
                    {"data": "Utid"},
                    {"data": "Card Number"},
                    {"data": "Acquiring Bank"},
                    {"data": "Issuer Bank"},
                    {"data": "Tender Mode"},
                    {"data":"Scheme"},
                    {"data":"Grade"},
                    {"data":"Credit/Debit"},
                    {"data":"RRN No"},
                    {"data":"Approval Code"},
                    {"data": "Merchant Invoice Number"},
                    {"data": "Batchsrl"},
                    {"data": "Invoice"},
                    {"data": "Bank Merchant Id"},
                    {"data": "Processing Code"},
                    {"data": "Transaction Type"},
                    {"data": "Card Holder Name"},
                    {"data": "Is DCC Transaction"},
                    {"data": "Is International Card"},
                    {"data": "Communication Id"},
                    {"data": "Software Version"},
                    {"data": "Terminal Serial Number"},
                    {"data": "Bill Invoice Number"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"}
                ],
                "columnDefs": [
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2]
                    },

                ],
            });
    }

    eslipReportDownloadCheck(type,e){
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            utid: this.state.ciutidIds,
            type: type,
            download: 1

        }
        this.setState({
            filters:filters
        })
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/debug-report/echargeslip-transaction-details','eChargeSlip_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/debug-report/echargeslip-consolidated','eChargeSlip_report');
        }
    }

//     _getAllMerchants(){
//         axios.get(config.get('API_URL')+'/reports/get-merchant/',{
//             headers: {
//                 Authorization: ` ${localStorage.usertoken}`
//             }
//         }).then(response => {
//             if(Array.isArray(response.data) && response.data.length) {
//                 var mList = []
//                 response.data.map((merchant, index) => {
//                     mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
//                 });
//                 this.setState({
//                     merchantList:mList,
//                     is_merchant_loading: false
//                 })
//             }
//         });
//     }
//
//     changeMerchant(login_type, optionSelected){
//         let value='';
//         let midArray = [];
//         if(optionSelected.length<1){
//             value = null;
//             midArray = '';
//         }
//         else{
//             optionSelected.map((mids, i) => {
//                 midArray.push(mids.value)
//                 if (login_type != 'merchant') {
//                     var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
//                     this.state.merchantList.move(index, 0).join(',');
//                 }
//             });
//         }
//         var is_enable = compareValues(midArray, this.state.active_mids);
//         this.setState({
//             merchantID:midArray,
//             chainID:'',
//             merchantValue:optionSelected,
//             chainValue:[],
//             storeID:'',
//             storeValue: [],
//             ciutidIds: '',
//             ciutidValue: [],
//             isChange: is_enable,
//             search_code: midArray,
//             search_type:'merchant',
//             storeObject:[],
//             search_object_code: this.state.object_code,
//         });
//         // this.get_filtered_echarge_slip_report(midArray, '', '', '', this.state.yestSend, this.state.todSend);
//         if(login_type==''){
//             this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
//             this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
//         }
//         this.ci_utid(midArray, '','', false,'');
//
//     }
//
//     changeChain(login_type, optionSelected) {
//         let value='';
//         let cidArray = [];
//         if(optionSelected.length<1){
//             value = null;
//             cidArray = '';
//         }
//         else{
//             optionSelected.map((cids, i) => {
//                 cidArray.push(cids.value)
//                 if (login_type != 'chain') {
//                     var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
//                     this.state.chainList.move(index,0).join(',');
//                 }
//             });
//         }
//         var is_enable = compareValues(cidArray, this.state.active_cids);
//         this.setState({
//             chainID: cidArray,
//             chainValue:optionSelected,
//             storeID:'',
//             storeValue: [],
//             ciutidIds: '',
//             ciutidValue: [],
//             isChange: is_enable,
//             search_code: cidArray,
//             search_type:'chain',
//             storeObject:[],
//             search_object_code: this.state.merchantID,
//         });
//         // this.get_filtered_echarge_slip_report(this.state.merchantID, cidArray, '', '',
//         //     this.state.yestSend, this.state.todSend);
//
//         if(login_type==''){
//             this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
//         }
//         this.ci_utid(this.state.merchantID, cidArray, '', false,'');
//     }
//     getChain(code, type, object_type, object_code){
//         axios.post(config.get('API_URL')+'/reports/get-chain/',{
//                 code: code,
//                 type: type,
//                 object_type: object_type,
//                 object_code: object_code
//             },
//             {
//                 headers: {
//                     Authorization: ` ${localStorage.usertoken}`
//                 },
//
//             }).then(response => {
//             let chalinList = [];
//             this.setState({chainID:''});
//             response.data.map((chain,index) => {
//                 chalinList.push({value: chain.chain_code, label: chain.chain_name})
//             });
//             this.setState({
//                 chainList:chalinList,
//                 is_chain_loading: false
//             })
//         });
//     }
//     getStore(code, type, object_type, object_code,is_search, search_value) {
//         let selected_val = [];
//         if(is_search===true){
//             selected_val = this.state.storeObject
//         }
//         this.setState({
//             storeList:[],
//             is_store_loading: true
//         })
//         axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
//                 code: code,
//                 type: type,
//                 object_type: object_type,
//                 object_code: object_code,
//                 is_search: is_search,
//                 search_value: search_value,
//                 selected_value: selected_val
//             },
//             {
//                 headers: {
//                     Authorization: ` ${localStorage.usertoken}`
//                 }
//
//             }).then(response => {
//             let storeList = [];
//             //this.setState({storeID:''});
//             response.data.map((store,index) => {
//                 storeList.push({value: store.store_code, label: store.store_name})
//             });
//             let res = []
//             if (Array.isArray(this.state.storeID) && this.state.storeID) {
//                 const uniq = new Set(storeList.map(e => JSON.stringify(e)));
//
//                 storeList = Array.from(uniq).map(e => JSON.parse(e));
//
//             }
//             this.setState({
//                 storeList:storeList,
//                 is_store_loading: false
//             })
//         });
//     }
//     changeStore(login_type, store_object, checked_item, e) {
//         if (login_type === 'store') {
//             let value='';
//             let sidArray = [];
//             if(store_object.length<1){
//                 value = null;
//                 sidArray = '';
//             }
//             else{
//                 store_object.map((sids, i) => {
//                     sidArray.push(sids.value)
//                 });
//             }
//             var is_enable = compareValues(sidArray, this.state.active_sids);
//             this.setState({
//                 storeID: sidArray,
//                 storeValue:store_object,
//                 ciutidIds: '',
//                 ciutidValue: [],
//                 isChange: is_enable
//             });
//         } else {
//             let item_list = this.state.storeID;
//             let item_list_object = this.state.storeObject;
//             let checked_list = store_object.value;
//             let checked_list_object = store_object;
//             //console.log(checked_list);
//             if(checked_item===false) {
//                 const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
//                 this.setState({
//                     storeID: [...this.state.storeID,  store_object.value],
//                     storeObject: [...this.state.storeObject, store_object],
//                     isChange: true,
//                     storeList: newData,
//                     ciutidIds: '',
//                     ciutidValue: [],
//                 });
//
//             } else{
//                 let index = item_list.indexOf(checked_list);
//                 if (index > -1) {
//                     item_list.splice(index, 1);
//                     if(item_list.length<1) {
//                         item_list='';
//                     }
//                     this.setState({
//                         storeID: item_list,
//                         isChange: true,
//                         ciutidIds: '',
//                         ciutidValue: [],
//                     })
//                 }
//                 let index_object = item_list_object.indexOf(checked_list_object);
//                 if (index_object > -1) {
//                     item_list_object.splice(index_object, 1);
//                     if(item_list_object.length<1) {
//                         item_list_object=[];
//                     }
//                     this.setState({
//                         storeObject: item_list_object,
//                         isChange: true
//                     })
//                 }
//             }
//             if (e.target.type === 'checkbox') {
//                 e.stopPropagation();
//             }
//         }
//
//         setTimeout(function() {
//             this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, false, '');
//         }.bind(this), 200);
//     }
//     storeToggleList() {
//         this.setState({
//             storeListOpen: !this.state.storeListOpen,
//         });
//     }
//     storeFilterList(e){
//         var value = e.target.value
//
//         setTimeout(function() {
//             this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
//         }.bind(this), 200);
//     }
//     closeStoreList() {
//         this.setState({
//             storeListOpen: false,
//         });
//     }
//
//     handleEvent(event, picker, e) {
//         this.setState({
//             todSend: moment(picker.endDate).format('YYYY-MM-DD'),
//             yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
//             datefromShow: moment(picker.startDate).format('D MMM YYYY'),
//             dateToShow: moment(picker.endDate).format('D MMM YYYY')
//         });
//         if(event.type=='apply'){
//             var is_date_change = false;
//             if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
//                 is_date_change = false;
//             } else {
//                 is_date_change = true;
//             }
//             this.setState({
//                 isChange: is_date_change
//             })
//             // this.get_filtered_echarge_slip_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.ciutidIds,
//             //     this.state.yestSend, this.state.todSend)
//         }
//         //this.refressOnDateChange();
//     }
//
//
//
//
//     ci_utid(mid,cid,sid,is_search, search_value) {
//         let utidList = [];
//         let selected_val = '';
//         if(is_search===true){
//             selected_val = this.state.ciutidIds
//         }
//         this.setState({
//             ciutidList: [],
//             is_utid_loading: true
//         })
//         axios.post(config.get('API_URL') + '/reports/get-utid/', {
//
//                 mid: mid,
//                 cid: cid,
//                 sid: sid,
//                 is_search:is_search,
//                 search_value: search_value,
//                 selected_value: selected_val
//             },
//             {
//                 headers: {
//                     Authorization: ` ${localStorage.usertoken}`
//                 }
//             }).then(response => {
//
//             if (Array.isArray(response.data) && response.data.length) {
//                 response.data.map((ci_utid, index) => {
//                     utidList.push(ci_utid.utid)
//                 });
//                 if (Array.isArray(this.state.ciutidIds) && this.state.ciutidIds) {
//                     utidList = utidList.filter( ( el ) => !this.state.ciutidIds.includes( el ) );
//                     this.state.ciutidIds.map((ut,index) => {
//                         utidList = [ut, ...utidList.filter(item => item !== ut)];
//                     })
//
//                 }
//                 this.setState({
//                     ciutidList: utidList,
//                     is_utid_loading: false
//                 })
//
//             } else {
//
//                 this.setState({
//                     ciutidList: [],
//                     is_utid_loading: false
//                 })
//             }
//
//         });
//     }
//
//     filterList(e){
//
//         var value = e.target.value
//         setTimeout(function() {
//             this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
//         }.bind(this), 200);
//     }
//     toggleList() {
//         this.setState({
//             listOpen: !this.state.listOpen,
//         });
//     }
//
//     changeUtid(utid,checked_item, e){
//         let item_list = this.state.ciutidIds
//         let checked_list = utid;
//         //console.log(checked_list);
//         if(checked_item===false) {
//             const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
//             this.setState({
//                 ciutidIds: [...this.state.ciutidIds,  utid],
//                 isChange: true,
//                 ciutidList: newData
//             });
//
//         } else{
//             let index = item_list.indexOf(checked_list);
//             if (index > -1) {
//                 item_list.splice(index, 1);
//                 if(item_list.length<1) {
//                     item_list='';
//                 }
//                 this.setState({
//                     ciutidIds: item_list,
//                     isChange: true
//                 })
//             }
//         }
//
//
//         if (e.target.type === 'checkbox') {
//             e.stopPropagation();
//         }
//     }
//     eslipReportDownloadCheck(type,e){
//
//     if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds===''){
//       confirmAlert({
//             //title: 'Warning',
//             message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
//             buttons: [{
//                 label: 'OK',
//                 onClick: () => {
//                     this.eslipReportDownload(type);
//                 }
//             },
//                 {
//                     label: 'Cancel',
//                 }
//             ]
//         });
//         } else {
//         this.eslipReportDownload(type)
//         }
//     }
//     eslipReportDownload (type, e){
//         var a = moment(this.state.todSend);
//         var b = moment(this.state.yestSend);
//         var days_beet = a.diff(b, 'days');
//         if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
//             alert("Date range too large. Please select a date range of "+ config.get('REPORT_CSV_DAYS_LIMIT')+ " days at a time");
//             return false;
//         }
//         this.setState({
//             is_download: false,
//             model_visible: true,
//             file_url: '',
//             rfile: '',
//             fetch_data:false
//         });
//         var postData = {
//             mids: this.state.merchantID,
//             cids: this.state.chainID,
//             sids: this.state.storeID,
//             yestSend: this.state.yestSend,
//             todSend: this.state.todSend,
//             download: true,
//             utid: this.state.ciutidIds,
//             type: type
//
//         };
//
//         let xhrBank = $.ajax({
//             url:config.get('API_URL')+ "/reports/eslip-reports-download",
//             type: "POST",
//             data: postData,
//             beforeSend: function (request) {
//                 request.setRequestHeader("Authorization", localStorage.usertoken);
//             },
// //             xhrFields: {
// //                 responseType: 'blob'
// //             },
//             success: function (response, status, xhr) {
//                 this.copyEslipFile(response.data, type);
//                 this.setState({
//                     fetch_data:true
//                 })
//             }.bind(this)
//         });
//         this.setState({
//             xhrBank: xhrBank
//         })
//
//     }
//     copyEslipFile(remotePath, type){
//         var postData = {
//             remotePath: remotePath
//         }
//
//         let xhrBank = $.ajax({
//             url:config.get('API_URL')+ "/reports/copy-file",
//             type: "POST",
//             data: postData,
//             beforeSend: function (request) {
//                 request.setRequestHeader("Authorization", localStorage.usertoken);
//             },
//             xhrFields: {
//                 responseType: 'blob'
//             },
//             success: function (response, status, xhr) {
//                 let blob = new Blob([response], {
//                     type: "octet/stream"
//                 });
//                 let fileName = timestamp+'eChargeSlip_report.csv.gz';
//                 let rfile = fileName.replace(/\"/g, "");
//                 //console.log(fileName)
//                 //let a = document.createElement('a');
//                 let url = window.URL.createObjectURL(blob);
//                 // a.href = url;
//                 // a.download = rfile;
//                 // a.click();
//                 // window.URL.revokeObjectURL(url);
//                 this.setState({
//                     is_download: true,
//                     file_url: url,
//                     rfile: rfile
//                 })
//             }.bind(this)
//         });
//         this.setState({
//             xhrBank: xhrBank
//         })
//
//     }
//     downloadFile(e){ //alert(this.state.file_url);
//         let a = document.createElement('a');
//         a.href = this.state.file_url;
//         a.download = this.state.rfile;
//         a.click();
//         window.URL.revokeObjectURL(this.state.file_url);
//     }
//     closeModal() {
//         this.setState({
//             model_visible : false
//         });
//     }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            ciutidValue: [],
            ciutidIds: '',

        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });


    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    render() {
        return(
        
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">eChargeSlip Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>
                                        {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>

                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_echarge_slip_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp;&nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="emi-zone-head">Consolidated</div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.eslipReportDownloadCheck.bind(this,'Consolidated')}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="eslipTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="100px">Merchant</th>
                                                    <th width="100px">Chain</th>
                                                    <th width="100px">Store Name</th>
                                                    <th width="150px">Store Address </th>
                                                    <th>City</th>
                                                    <th>BTID</th>
                                                    <th>UTID</th>
                                                    <th>Total No of transactions</th>
                                                    <th>Transactions on Echargeslip</th>
                                                    <th>Transactions on Paper roll</th>


                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <br/>
                                    <div className="emi-zone-head">Transaction Details</div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.eslipReportDownloadCheck.bind(this,'details')}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="eslipTableDetails" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                {/*<th>prim_id</th>*/}
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store</th>
                                                <th>Store Address 1</th>
                                                <th>Store Address 2</th>
                                                <th>City</th>

                                                <th>Amount</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Acquirer Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Tender Mode</th>
                                                <th>Scheme</th>
                                                <th>Grade</th>
                                                <th>Credit/Debit</th>
                                                <th>RRN No</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Processing Code</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Is DCC Transaction</th>
                                                <th>Is International Card</th>
                                                <th>Communication Id</th>
                                                <th>Software Version</th>
                                                <th>Terminal Serial Number</th>
                                                <th>Bill Invoice Number</th>
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>


                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( PhonePeTransactionReport );